import { render, staticRenderFns } from "./videoInformation.vue?vue&type=template&id=6d19aa44"
import script from "./videoInformation.vue?vue&type=script&lang=js"
export * from "./videoInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports